import { privateApi } from 'services';
import { JobCampaignCollectionDataItem } from './types';

const fetchCampaigns = async (jobGroupId: string, params?: string): Promise<JobCampaignCollectionDataItem[]> => {
    let searchParamsString: string = '';
    const searchParams = params?.trim() ?? '';
    if (searchParams) {
        searchParamsString = searchParams.charAt(0) === '?' ? searchParams : `?${searchParams}`;
    }

    return privateApi.get<JobCampaignCollectionDataItem[]>(`job-groups/${jobGroupId}/campaigns${searchParamsString}`);
};

const deleteJobCampaign = async (jobCampaignId: string): Promise<JobCampaignCollectionDataItem> =>
    privateApi.delete<JobCampaignCollectionDataItem>(`job-campaigns/${jobCampaignId}`);

export const JobCampaignCollectionDataItemGateway = {
    fetchCampaigns,
    deleteJobCampaign,
};
